<mat-toolbar class="fw-light text-light" *ngIf="showToolbar">
  <mat-icon class="click-able me-4" (click)="dismiss()">close</mat-icon>
  Message Inspector
  <span class="flex-mid-spacer"></span>
  <button
    (click)="navigationStackPop()"
    [disabled]="navigationStack.length < 2"
    mat-icon-button>
    <mat-icon>arrow_back_ios</mat-icon>
  </button>
</mat-toolbar>
<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div *ngIf="result" class="m-2 fw-light scrollable-container">
  <div class="d-block mx-2">
    <div><span class="fw-bold me-2">From:</span>{{result.sender}}</div>
    <div class="font-size-12 fw-light text-secondary ms-4 mb-2">
      <div class="row m-0 p-0">
        <span class="col-6 col-md-3 col-lg-1 m-0 p-0">Timestamp:</span>
        <span class="col-6 col-md-9 col-lg-11">{{result.timestamp | date: 'MMM dd HH:mm:ss'}}</span>
      </div>
      <div class="row m-0 p-0" *ngIf="result.refId">
        <span class="col-6 col-md-3 col-lg-1 m-0 p-0">Replying To:</span>
        <span class="col-6 col-md-9 col-lg-11">
          <a class="link-underline-light"
            [routerLink]="['../', result.refId]">{{result.refId}}</a></span>
      </div>
    </div>
    <div><span class="fw-bold me-2">Message:</span>
      <a
        class="click-able link-underline-light font-size-14"
        (click)="showFullMessageText = !showFullMessageText">
        {{showFullMessageText ? 'less' : 'more...'}}
      </a>
    </div>
    <div class="font-size-12 fw-light text-secondary ms-4 mb-2">
      <span class="d-inline-block text-truncate" style="max-width: 95%" *ngIf="!showFullMessageText">
        {{result.message}}
      </span>
      <div *ngIf="showFullMessageText">{{result.message}}</div>
    </div>
    <div *ngIf="result.stats && result.stats.tokenUsage" class="mb-2">
      <div class="fw-bold me-2 mb-2">Stats</div>
      <div class="font-size-12 fw-light text-secondary ms-4 mb-2">
        <div class="row m-0 p-0">
          <span class="col-6 col-md-3 col-lg-1 m-0 p-0">Token usage:</span>
          <span class="col-6 col-md-9 col-lg-11">
            <span class="fw-bold">{{result.stats.tokenUsage['prompt_tokens']}}</span> (Prompt),
            <span class="fw-bold">{{result.stats.tokenUsage['completion_tokens']}}</span> (Completion),
            <span class="fw-bold">{{result.stats.tokenUsage['total_tokens']}}</span> (Total)
          </span>
        </div>
        <div class="row m-0 p-0" *ngIf="result.stats['delta']">
          <span class="col-6 col-md-3 col-lg-1 m-0 p-0">Delay</span>
          <span class="col-6 col-md-9 col-lg-11">
            <span class="fw-bold">{{result.stats['delta'] | number: '1.2-2'}}</span> secs
          </span>
        </div>
      </div>
    </div>
    <div *ngIf="result.stats && result.stats.intentState">
      <div class="fw-bold me-2 mb-2">Intent:</div>
      {{ result.stats.intentState | json }}
    </div>
    <div *ngIf="result.stats && result.stats.ragResults">
      <div class="fw-bold me-2 mb-2">Embeddings:</div>
      <mat-accordion>
        <mat-expansion-panel *ngFor="let item of result.stats.ragResults">
          <mat-expansion-panel-header>
            <mat-panel-title>{{item['collection']}}</mat-panel-title>
            <mat-panel-description>
              <div *ngIf="item['matches']">
                {{item['matches'].length}} matches
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div *ngIf="item['matches']">
            <data-table
              [columnOptions]="{
              '$$raw': { hidden: true },
              'id': { heading: 'Id', order: 1 },
              'entity': { heading: 'Text Details', order: 2, renderTemplate: cellTextDetails },
              'distance': { heading: 'Score', order: 3, renderTemplate: cellScore },
            }"
              [items]="item['matches']"
            ></data-table>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>

<ng-template #cellTextDetails let-cellItem=cellItem>
  <div>
    {{cellItem['text']}}
  </div>
  <div class="row p-0 m-0">
    <div class="col-12 col-md-6 m-0 p-0" *ngIf="cellItem['source']">
      <span class="mx-2">Source: </span>
      <ng-container [ngSwitch]="isValidHttpUrl(cellItem['source'])">
        <a *ngSwitchCase="true"
           class="link-underline-light" target="_blank" href="{{cellItem['source']}}">{{cellItem['source']}}</a>
        <span *ngSwitchCase="false">
          {{cellItem['source']}}
        </span>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #cellScore let-cellItem=cellItem>
  <span class="text-primary">{{cellItem | number: '1.1-5'}}</span>
</ng-template>
